import { defineCustomElements } from '@vanmossel-ui/components/loader';
import Tracking from './modules/Tracking';
import Nav from './modules/Nav';
import Header from './modules/Header';
import Hero from './modules/Hero';
import Tooltip from './modules/Tooltip';
import StickyMenu from './modules/StickyMenu';
import LocationMap from './modules/LocationMap';
import NewsOverview from './modules/NewsOverview';
import LogoCarousel from './modules/LogoCarousel';
import DealerOverview from './modules/DealerOverview';
import DealerDetail from './modules/DealerDetail';
import AppearingField from './modules/AppearingField';
import DealerFilter from './modules/DealerFilter';
import { ResizeService } from './modules/ResizeService';
import ContactFormEstablishmentSelect from './modules/ContactFormEstablishmentSelect';
import HeroSlider from './modules/HeroSlider';
class App {
    resizeService;
    constructor() {
        document.addEventListener('DOMContentLoaded', this.init);
    }
    init() {
        defineCustomElements();
        new Tracking();
        this.resizeService = new ResizeService();
        new Nav(this.resizeService);
        new Header(this.resizeService);
        new Hero(this.resizeService);
        new Tooltip();
        new StickyMenu();
        const locationMap = new LocationMap();
        new NewsOverview();
        const dealerOverview = new DealerOverview();
        new DealerDetail();
        const typeSelect = document.querySelector('select.js-dynamicestablishment-typeselect');
        typeSelect && new ContactFormEstablishmentSelect(typeSelect);
        Array.from(document.querySelectorAll('.js-logo-carousel')).map((element) => new LogoCarousel(element));
        Array.from(document.querySelectorAll('.field.js-appearing-field')).map((element) => new AppearingField(element));
        const firstFilterElement = document.querySelector('.js-dealer-filter'); //Only one instance for filters needed
        if (firstFilterElement) {
            const dealerFilterInstance = new DealerFilter(firstFilterElement, dealerOverview, locationMap);
        }
        // Heroslider
        Array.from(document.querySelectorAll('.js-heroslider')).map((element) => new HeroSlider(element));
    }
}
;
window.app = new App();
